/* @ngInject */

export default () => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function FeeAndChargeType(name, id, weight) {
    this.name = name;
    this.id = id;
    this.weight = weight;
  }

  /*
   * Public properties
   * --------------------------------------------------------------------------------
   */
  FeeAndChargeType.default = { id: 'provision_of_credit_assistance', weight: 1 };
  FeeAndChargeType.availableTypes = [
    { id: 'provision_of_credit_assistance', weight: 1 },
    { id: 'costs_incurred_by_us', weight: 2 },
    { id: 'payments_made_on_your_behalf', weight: 3 }
  ];
  FeeAndChargeType.available = _.map(
    FeeAndChargeType.availableTypes,
    (feeAndChargeType) =>
      new FeeAndChargeType(
        feeAndChargeType.id.sanitize(),
        feeAndChargeType.id,
        feeAndChargeType.weight
      )
  );

  /*
   * Private methods
   * --------------------------------------------------------------------------------
   */
  function checkFeeAndChargeType(id) {
    const index = _.findIndex(FeeAndChargeType.availableTypes, { id });
    return index !== -1;
  }

  /*
   * Public methods
   * --------------------------------------------------------------------------------
   */
  FeeAndChargeType.prototype.getName = function () {
    return this.name;
  };

  /*
   * Static methods
   * --------------------------------------------------------------------------------
   */
  FeeAndChargeType.Build = function (data) {
    if (!data || !data.id || !checkFeeAndChargeType(data.id)) {
      return new FeeAndChargeType(
        FeeAndChargeType.default.id.sanitize(),
        FeeAndChargeType.default.id,
        FeeAndChargeType.default.weight
      );
    }
    return new FeeAndChargeType(data.name, data.id, data.weight);
  };

  return FeeAndChargeType;
};
